import Reveal from '@/components/base/Reveal';
import { leadsSystem } from '@/mocks/home';

export default function SystemBehind() {
  return (
    <section className="relative py-20 md:py-28 bg-background-100/40">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <Reveal className="text-center max-w-2xl mx-auto">
          <span className="inline-flex items-center gap-2 rounded-full border border-primary-500/30 bg-primary-500/10 px-4 py-1.5 text-xs font-label font-semibold text-primary-400">
            Josh&rsquo;s Methodology
          </span>
          <h2 className="mt-6 font-heading font-bold text-3xl md:text-4xl text-foreground-950">
            The L.E.A.D.S. System™
          </h2>
          <p className="mt-4 text-foreground-600">
            Years of experience developed into a structured methodology used to
            identify bottlenecks and build more repeatable, measurable growth.
          </p>
        </Reveal>

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
          {leadsSystem.map((item, i) => (
            <Reveal key={item.letter} delay={i * 80}>
              <div className="h-full rounded-xl border border-white/8 bg-background-100 p-6 hover:border-primary-500/30 transition-colors">
                <div className="flex items-center justify-between">
                  <span className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-500/15 text-primary-400 font-heading font-extrabold text-xl">
                    {item.letter}
                  </span>
                  <span className="text-xs font-label font-semibold text-foreground-600">
                    {String(i + 1).padStart(2, '0')}
                  </span>
                </div>
                <h3 className="mt-5 font-heading font-semibold text-base text-foreground-950">
                  {item.title}
                </h3>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed">
                  {item.desc}
                </p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal className="mt-14 text-center">
          <h3 className="font-heading font-bold text-2xl text-foreground-950">
            One System. Two Ways to Implement It.
          </h3>
        </Reveal>

        <div className="mt-8 grid grid-cols-1 lg:grid-cols-2 gap-6">
          <Reveal delay={0}>
            <div className="h-full rounded-2xl border border-white/10 bg-background-50 p-7">
              <span className="inline-flex items-center gap-2 rounded-full bg-primary-500/15 text-primary-400 px-3 py-1 text-xs font-label font-semibold">
                <i className="ri-sparkling-2-line"></i>
                Done For You
              </span>
              <h3 className="mt-4 font-heading font-semibold text-lg text-foreground-950">
                Done For You Marketing
              </h3>
              <p className="mt-2 text-sm text-foreground-600 leading-relaxed">
                Josh and the team help implement and manage the marketing
                infrastructure and campaigns end to end.
              </p>
            </div>
          </Reveal>

          <Reveal delay={100}>
            <div className="h-full rounded-2xl border border-white/10 bg-background-50 p-7">
              <span className="inline-flex items-center gap-2 rounded-full bg-accent-500/15 text-accent-400 px-3 py-1 text-xs font-label font-semibold">
                <i className="ri-compass-3-line"></i>
                Done With You
              </span>
              <h3 className="mt-4 font-heading font-semibold text-lg text-foreground-950">
                Done With You Consulting
              </h3>
              <p className="mt-2 text-sm text-foreground-600 leading-relaxed">
                Josh works strategically alongside the business owner or
                existing marketing team.
              </p>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
